import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { screenXsMax, screenMdMax } from '@spotify-internal/encore-web';

const AttributePair = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 80px;

  @media (max-width: ${screenMdMax}) {
    margin-right: 48px;
  }

  @media (max-width: ${screenXsMax}) {
    align-items: start;
  }
`;

const AttributeText = styled.div`
  display: inline-block;
  line-height: 1.33;
  font-size: 14px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.4);

  @media (max-width: ${screenXsMax}) {
    margin-right: 12px;
  }
`;

const Label = styled(AttributeText)`
  margin-bottom: 4px;

  @media (max-width: ${screenXsMax}) {
    margin-bottom: 0;
  }
`;

const Value = styled(AttributeText)`
  letter-spacing: 0.3px;
  line-height: 1.43;
  font-size: 14px;
  color: black;
`;

export default function EntityAttribute({
  label,
  value,
  hasPriority = false,
  className = undefined,
  ...otherProps
}) {
  return (
    <AttributePair data-priority={hasPriority} className={className} {...otherProps}>
      <Label>{label}</Label>
      <Value>{value || '-'}</Value>
    </AttributePair>
  );
}

EntityAttribute.propTypes = {
  /** Node containing for the label. */
  label: PropTypes.node.isRequired,
  /** Node containing for the value under the label. If empty or undefined, defaults to "-" */
  value: PropTypes.node,
  /** Boolean assigning "priority", which determines which attribute appears in the mobile view. Should be passed to one pair only. If passed to multiple, will only apply to the first child with priority */
  hasPriority: PropTypes.bool,
  className: PropTypes.string,
};
